export default {"src":"/_next/static/media/calendar-alert.aff8d7b7.svg","height":21,"width":23,"blurWidth":0,"blurHeight":0};